<template>
      
  <div name="fade" class="container">
    <!-- <ScaleScreen
     
      width="1920"
      height="1080"
      :fullScreen="false"
      :autoScale="true"
    > -->
    <router-view></router-view>
    <WebSocket ref="childWs" :merchantId="realMerchantId" :signReq="signString"></WebSocket>
  <!-- </ScaleScreen> -->
  </div>

</template>

<script>
import WebSocket from './views/components/WebSocket/WebSocket.vue';  
import { getMerchantConfigData } from './views/v2/api/'; 
import ScaleScreen from "./views/components/scale-screen/index.vue";

export default {
  components:{WebSocket,ScaleScreen},
  data() {
    return {
      signString:'',
      merchantId:0,
    };
  },
  computed: {
    key() {
      console.log(this.$route.path)
      return this.$route.path + Math.random();
    }
  },
  created() {
    this.initConfig()
  },
  mounted() {
    this.getBaseInfo()
    console.log('app vue')
  },
  methods:{
    initConfig(){
      this.$config.sign = this.getUrlCode('sign')||'';
      this.$config.merchantId = this.getUrlCode('merchantId')||0;
      this.$config.signSecret = this.getUrlCode('signSecret')||'none'
      this.$config.mirrorType = this.getUrlCode('mirrorType')||'none'
      this.$config.realMerchantId = Number(this.$config.merchantId)
      this.merchantId = Number(this.$config.merchantId)
      this.realMerchantId = Number(this.$config.merchantId)
      this.signString = this.$config.sign
      this.$config.queryParams = `?merchantId=${this.$config.merchantId}&sign=${this.$config.sign}&signSecret=${this.$config.signSecret}`
      if(location.hash.split('/')[1]==this.$config.visualPath){
        this.$config.openVisual = true
      }
      if(this.$config.openVisual && this.$config.mirrorType=='full'){
        this.$config.merchantId = 1;
        this.$config.queryParams = this.$config.queryParams+"&mirrorType=full"
      }
      console.log(this.$config)
    },
    getBaseInfo(){
      getMerchantConfigData({merchantId:this.realMerchantId}).then(res=>{
        this.$config.baseInfo = res.data
        if(this.$config.openVisual) this.$config.ratio = res.data
      })
    },
    getUrlCode(name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
    },
  }
};
</script>

<style>
body {
  margin: 0px;
}
html {
  font-size: 16px;
}

/* Chrome */
@media screen and (min-width: 1367px) and (max-width: 2160px) and (-webkit-min-device-pixel-ratio: 0) {
  html {
    font-size: 13px;
  }
}

.container{
  background-image: url(../src/views/v2/images/bg.png);
  background-size: 100% 100%;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  /* background-color: #07227d; */
}
</style>
